import { clearAllTokens } from "@/shared/auth/tokenStorage";
import { markAuthSessionInvalidHandled } from "@/shared/auth/authSessionEvents";
import { queryClient } from "@/shared/api";
import { useUserStore } from "@/entities/user";

/**
 * 세션 teardown 단일 진입점(#394) — 토큰 → 사용자 스토어 → 서버상태 캐시 순으로 비운다.
 *
 * 세션이 끝나는 경로는 둘이다: (1) useAuthNavigation.logOut — 모든 세션무효(자동 401·계정상태·명시
 * 로그아웃)가 수렴하는 chokepoint(useAuthSessionRecovery 가 세션무효 이벤트마다 호출), (2) SNS 로그인
 * 직후 계정상태 오류(탈퇴·정지·차단) 분기 — logOut 을 거치지 않고 직접 정리한다. 둘이 같은 헬퍼를 써야
 * 서버 읽기를 TSQ 로 옮길수록 한쪽만 캐시를 남기는 구멍이 안 생긴다(ADR 260908-03).
 *
 * queryClient.clear() 는 캐시 제거 + 진행 중 쿼리의 TSQ 관찰 상태 silent cancel 까지다. 실제 HTTP abort 는
 * queryFn 이 `signal` 을 fetcher 로 넘길 때만 일어난다(§4 — 현재 넘기지 않는다). 다른 계정으로 SPA
 * 로그인 시 같은 key 의 이전 계정 데이터(계약·recent·프로필 등) 노출을 막는 것이 목적(#257 과 같은 취지).
 *
 * 위치가 features/auth/lib 인 이유: userStore(entities)를 부르므로 shared 에 두면 shared → entities
 * 상향 의존이 된다. 네비게이션(로그인 화면 이동)은 호출처의 몫이다.
 *
 * 진입 시 세션 무효 가드를 세운다(#405): 이 시점 이후 도착하는 401(exit 중 옵저버 재요청, 지연 응답)은
 * 이미 끝난 세션의 잔향이라 다시 logOut·팝업을 만들면 안 된다. 가드는 다음 setToken 에서 풀린다.
 */
export const teardownSession = (): void => {
  markAuthSessionInvalidHandled();
  clearAllTokens();
  useUserStore.getState().clearUser();
  queryClient.clear();
};
